let currentPage = 1;
let currentFilters = {};
let postsLoaded = 0;
let totalItems = 0;

export function initBlogPosts(filters = {}) {
    currentPage = 1;
    currentFilters = filters;
    postsLoaded = 0;
    totalItems = 0;
    loadBlogPosts(currentFilters, currentPage, false);

    const loadMoreBtn = document.getElementById('loadMoreBtn');
    loadMoreBtn?.addEventListener('click', () => {
        currentPage++;
        loadBlogPosts(currentFilters, currentPage, true);
    });
}

function loadBlogPosts(filters, page = 1, append = false) {
    const container = document.getElementById('recentPostsContainer');
    const pageId = container?.dataset.pageId;
    const loadMoreBtn = document.getElementById('loadMoreBtn');
    const progressText = document.getElementById('postProgressText');
    const progressBar = document.getElementById('postProgressBar');

    if (!container || !pageId) return;

    const queryParams = new URLSearchParams({ page });
    if (filters.topic?.length) filters.topic.forEach(val => queryParams.append('tags', val));
    if (filters.segment?.length) filters.segment.forEach(val => queryParams.append('segments', val));

    const apiUrl = `/api/Blogs/${pageId}/RecentPosts?${queryParams.toString()}`;

    fetch(apiUrl)
        .then(response => {
            if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);
            return response.json();
        })
        .then(data => {
            if (!data.items?.length) {
                if (!append) container.innerHTML = '<p>No recent posts found.</p>';
                loadMoreBtn.style.display = 'none';
                return;
            }

            if (!append) {
                container.innerHTML = '';
                postsLoaded = 0;
            }

            data.items.forEach(post => {
                const postCard = document.createElement('div');
                postCard.className = 'tmp-overviewblog__card';
                postCard.innerHTML = `
                    <a class="tmp-overviewblog__card-link" href="${post.url}">
                        <img src="${post.cardImage}" alt="${post.postTitle}" class="tmp-overviewblog__card-image" />
                        <div class="tmp-overviewblog__card-tags">
                            ${post.tags.map(tag => `<a href="${tag.url}" class="tag">${tag.name}</a>`).join(' ')}
                        </div>
                        <h3 class="tmp-overviewblog__card-title">${post.postTitle}</h3>
                    </a>
                    <p class="blog-post-card__card-description">${post.shortDescription}</p>
                    <a href="${post.url}" class="tmp-overviewblog__card-readmore">Read More</a>
                `;
                container.appendChild(postCard);
            });

            postsLoaded += data.items.length;
            totalItems = data.totalItems ?? totalItems;

            if (progressText && progressBar && totalItems > 0) {
                progressText.textContent = `Showing ${postsLoaded} of ${totalItems}`;
                const percent = (postsLoaded / totalItems) * 100;
                progressBar.style.width = `${Math.min(percent, 100)}%`;
            }

            if (postsLoaded >= totalItems || data.items.length < 12) {
                loadMoreBtn.style.display = 'none';
            } else {
                loadMoreBtn.style.display = 'inline-block';
            }
        })
        .catch(error => {
            console.error('Error loading blog posts:', error);
            if (!append) container.innerHTML = '<p>Error loading blog posts.</p>';
        });
}
